import { useRef } from "react";
import { ParentButton, SubText, Paper } from "@base-ui";
import Image from "@cms/components/ui/Image";
import { closePopup } from "utils/events";
import { useLockedFocusArea } from "hooks";
import R1C1_1 from "@cms/assets/grids/R1C1_1.png";
import R1CX_1 from "@cms/assets/grids/R1CX_1.png";
import R1C2_1x1 from "@cms/assets/grids/R1C2_1x1.png";
import R1C2_1x2 from "@cms/assets/grids/R1C2_1x2.png";
import R1C2_2x1 from "@cms/assets/grids/R1C2_2x1.png";
import R1C3_1x1x1 from "@cms/assets/grids/R1C3_1x1x1.png";
import R1C4_1x1x1x1 from "@cms/assets/grids/R1C4_1x1x1x1.png";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var grids = {
  R1C1_1: {
    label: "100%",
    alt: "Bild föreställande en kolumn",
    src: R1C1_1
  },
  R1C2_1x1: {
    label: "50% - 50%",
    alt: "Bild föreställande två likfördelade kolumner",
    src: R1C2_1x1
  },
  R1C2_1x2: {
    label: "33% - 66%",
    alt: "Bild föreställande två kolumner fördelade 33%/66%",
    src: R1C2_1x2
  },
  R1C2_2x1: {
    label: "66% - 33%",
    alt: "Bild föreställande två kolumner fördelade 66%/33%",
    src: R1C2_2x1
  },
  R1C3_1x1x1: {
    label: "33% - 33% - 33%",
    alt: "Bild föreställande tre likfördelade kolumner",
    src: R1C3_1x1x1
  },
  R1C4_1x1x1x1: {
    label: "25% - 25% - 25% - 25%",
    alt: "Bild föreställande fyra likfördelade kolumner",
    src: R1C4_1x1x1x1
  },
  R1CX_1: {
    label: "Karusell",
    alt: "Bild föreställande kolumner i en karusell grid",
    src: R1CX_1
  }
};
export default function SelectGridPopup(_ref) {
  var callback = _ref.callback,
    _ref$selectable = _ref.selectable,
    selectable = _ref$selectable === void 0 ? Object.keys(grids) : _ref$selectable;
  var containerRef = useRef();
  var firstRef = useRef();
  var lastRef = useRef();
  useLockedFocusArea(containerRef, firstRef, lastRef);
  var handleSelectGrid = function handleSelectGrid(type) {
    closePopup();
    callback({
      type: type
    });
  };
  var gridsMarkup = Object.keys(grids).filter(function (key) {
    return selectable.includes(key);
  }).map(function (key, idx) {
    var _grids$key = grids[key],
      label = _grids$key.label,
      alt = _grids$key.alt,
      src = _grids$key.src;
    var gridRef = idx === 0 ? firstRef : idx === grids.length - 1 ? lastRef : undefined;
    return /*#__PURE__*/_jsxs(ParentButton, {
      id: "select-grid-type-".concat(key),
      "aria-label": "V\xE4lj ".concat(label),
      ref: gridRef,
      onClick: function onClick() {
        return handleSelectGrid(key);
      },
      flexDirection: "column",
      alignItems: "center",
      p: "5px 10px",
      m: "5px",
      children: [/*#__PURE__*/_jsx(Image, {
        id: src,
        src: src,
        alt: alt,
        height: "60px",
        width: "auto",
        mb: "5px",
        objectFit: "contain"
      }), /*#__PURE__*/_jsx(SubText, {
        as: "label",
        htmlFor: "select-grid-type-".concat(key),
        children: label
      })]
    }, key);
  });
  return /*#__PURE__*/_jsx(Paper.Row, {
    p: "md",
    ref: containerRef,
    flexWrap: "wrap",
    maxWidth: "645px",
    children: gridsMarkup
  });
}